import React from "react";

import * as Styled from "./styles";

const CardContainer = ({ children }) => {
  return <Styled.Container>{children}</Styled.Container>;
};

export default CardContainer;
